module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImg3.8995c86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImg3.jpg
// module id = HI/5
// module chunks = 5